// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_FNs","cls2":"ExportFormatModal-cls2_oHe ExportFormatModal-cls1_FNs"};